import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-addthis',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>AddThis icon</title><path d="M18 13.496h-4.501v4.484h-3v-4.484H6v-2.99h4.5V6.021h3.001v4.485H18v2.99zM21 .041H3C1.348.043.008 1.379 0 3.031v17.94c.008 1.65 1.348 2.986 3 2.988h18c1.651-.002 2.991-1.338 3-2.988V3.031c-.009-1.652-1.348-2.987-3-2.99z"/></svg>`,
    styles: []
})
export class SimpleIconsAddthisComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF6550';
    @Input() className: string = 'simple-icons-addthis'
    constructor() {}
    ngOnInit(): void {}
}
